import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { SimpleHeaderComponent } from '../simple-header/simple-header.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-input-dialog',
  standalone: true,
  imports: [
    SimpleHeaderComponent,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    CommonModule,
    MatButtonModule
  ],
  template: `
<div class="container">
  <div class="scrollable-content">
    <simple-header (action)="this.dialogRef.close({closed: true})"  [title]="title" icon="close"></simple-header>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{inputLabel}}</mat-label>
      <input matInput [formControl]="input">
    </mat-form-field>
    <button [disabled]="!input.value?.trim()" mat-button color="primary" (click)="onSubmit()">Aceptar</button>
</div>
</div>
  `,
  styleUrls: ['./input-dialog.component.css'],
})
export class InputDialogComponent {
  title;
  inputLabel;
  input = new FormControl('', Validators.required);

  constructor(
    public dialogRef: MatDialogRef<InputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.title = data.title;
    this.inputLabel = data.inputLabel;
  }

  onSubmit() {
    this.dialogRef.close({closed: false, text: this.input.value?.trim()})
  }
}
